import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { SidebarMenu, type SidebarItem } from 'vue-sidebar-menu';
  import 'vue-sidebar-menu/dist/vue-sidebar-menu.css';
  import menuItems, { type AppMenuItem } from '@/assets/menu';
  import AppLogo from '@/components/widget/AppLogo.vue';
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import VersionInfo from '@/components/widget/VersionInfo.vue';
  import SelectedSubject from '@/components/widget/SelectedSubject.vue';
  import SubjectSettings from '@/components/widget/SubjectSettings.vue';
  import LogoutButton from '@/components/widget/LogoutButton.vue';
  import TimeToEndSession from '@/components/widget/TimeToEndSession.vue';
  import { useInteractionModeStore } from '@/store/interactionModeStore';
  import { InteractionModeEnum } from '@/types/InteractionModeEnum';

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LeftMenu',
  setup(__props) {

  const { t } = useI18n();
  const interactionModeStore = useInteractionModeStore();
  const isEditMode = computed(() => interactionModeStore.mode === InteractionModeEnum.EDIT);

  // Function to translate menu titles
  const translateMenu = (menu: AppMenuItem[], parentId = 'menu'): SidebarItem[] => {
    return menu.map((item, index) => {
      const { requiresEditMode, ...sidebarItem } = item;
      const itemId = item.id || `${parentId}-${index}`;
      const translatedItem: SidebarItem = {
        ...sidebarItem,
        id: itemId,
        title: t(item.title),
        hidden: item.hidden || (requiresEditMode && !isEditMode.value),
      };
      if (item.child) {
        translatedItem.child = translateMenu(item.child, itemId);
      }
      return translatedItem;
    });
  };

  const translatedMenu = computed(() => translateMenu(menuItems));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SidebarMenu), { menu: translatedMenu.value }, {
    header: _withCtx(() => [
      _createVNode(AppLogo, { class: "logo" }),
      _createVNode(SelectedSubject)
    ]),
    footer: _withCtx(() => [
      _createVNode(SubjectSettings),
      _createVNode(LogoutButton),
      _createVNode(VersionInfo),
      _createVNode(TimeToEndSession)
    ]),
    _: 1
  }, 8, ["menu"]))
}
}

})